import React, { Fragment, useState } from "react";
import AboutSection from "./AboutSection";

function CloadTop({ cloadOpacity }) {
  /*
  SkyAnimation-left
  SkyAnimation-center
  SkyAnimation-right
  */
  const [about, setAbout] = useState(false);
  return (
    <Fragment>
      <header
        onScroll={(e) => {
          console.log("onscroll :", e);
        }}
        className="w-full  z-40 fixed "
        style={{ height: "20vh" }}
      >
        <img
          src={require("../../assest/cload-right.png")}
          alt=""
          className=" absolute    SkyAnimation-left transition-all duration-300"
          style={{
            width: "300px",
            left: "100px",
            top: "70px",
            opacity: cloadOpacity,
          }}
        />
        <img
          src={require("../../assest/cload-center.png")}
          alt=""
          className="absolute left-0  SkyAnimation-center  transition-all duration-300"
          style={{
            width: "270px",
            left: "500px",
            top: "35px",
            opacity: cloadOpacity,
          }}
        />
        <img
          src={require("../../assest/cload-left.png")}
          alt=""
          className="absolute right-0 SkyAnimation-right transition-all duration-300"
          style={{
            width: "140px",
            right: "-50px",
            top: "30px",
            opacity: cloadOpacity,
          }}
        />
        <div
          className="hidden md:flex items-center w-1/2 text-white  text-sm  h-24 mr-16 justify-center  pt-5 "
          // style={{ fontFamily: "FFSakhr-Regular" }}
        >
          <span
            className="  py-2 px-5
            cursor-pointer rounded-full mr-32"
            style={{ border: "0.1px solid #aaa" }}
          >
            {" "}
            الرئيسية
          </span>
          <span className="cursor-pointer mr-32" onClick={() => setAbout(true)}>
            {" "}
            من نحن
          </span>
          <span className="cursor-pointer mr-32"> تواصل</span>
        </div>
      </header>
      <AboutSection open={about} onClose={() => setAbout(false)} />
      <div style={{ height: "20vh" }} />
    </Fragment>
  );
}

export default CloadTop;
